import get from 'lodash/get';
import set from 'lodash/set';
import forEach from 'lodash/forEach';
import { UPCOMING, UPCOMING_WITH_SESSIONS, RELEASED, CLOSED } from '../constants/moviesConst';

export const parseRunningMoviesMetricInfo = (apiResponse = {}) => {
	const data = get(apiResponse, 'data', {});
	return { data };
};

export const parseUpcomingMoviesMetricInfo = (apiResponse = {}) => {
	const data = {};
	const metricInfos = get(apiResponse, 'metricInfos', {});
	forEach(metricInfos, (value, key) => {
		set(data, `${key}.metricData`, value);
	});
	return { data };
};

const showLikeDislikeMap = {
	[UPCOMING]: false,
	[UPCOMING_WITH_SESSIONS]: false,
	[RELEASED]: true,
	[CLOSED]: true,
};

export const checkForShowLikeDislike = (status: number) => {
	return get(showLikeDislikeMap, status);
};
